// Merge-customer modal: search for the other customer, then pick which record
// to keep. Registered at boot so the modal works after a Turbo visit, when
// Alpine initializes the markup before any inline script could register it.
export default function registerCustomerMergeModal(Alpine) {
  Alpine.data("customerMergeModal", ({ searchUrl, currentId }) => ({
    searchUrl,
    currentId,
    query: "",
    results: [],
    showResults: false,
    loading: false,
    selected: null,
    keep: "current",

    async search() {
      if (this.query.length < 2) {
        this.results = [];
        this.showResults = false;
        return;
      }
      this.loading = true;
      try {
        const resp = await fetch(`${this.searchUrl}?q=${encodeURIComponent(this.query)}`);
        const data = await resp.json();
        this.results = data.filter((c) => c.id !== this.currentId);
        this.showResults = true;
      } finally {
        this.loading = false;
      }
    },

    choose(c) {
      this.selected = c;
      this.keep = "current";
      this.showResults = false;
      this.query = "";
      this.results = [];
    },

    clear() {
      this.selected = null;
    }
  }));
}
